import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTime',
})
export class DateTimePipe implements PipeTransform {
  transform(varDate: Date, showTime: boolean = false): string {
    let incomingDate: any = varDate;
    if (typeof varDate === 'string') {
      incomingDate = new Date(varDate);
    }
    const date = incomingDate.getDate();
    const month = incomingDate.getMonth() + 1; // Month from 0 to 11
    const year = incomingDate.getFullYear();

    let strTime;

    if (showTime) {
      let hours = incomingDate.getHours();
      let minutes = incomingDate.getMinutes();
      const ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      strTime = hours + ':' + minutes + ' ' + ampm;
    }

    const dateString =
      (date <= 9 ? '0' + date : date) +
      '-' +
      (month <= 9 ? '0' + month : month) +
      '-' +
      year;

    return strTime ? dateString + ' ' + strTime : dateString;
  }
}
